export const AUTH_LETTER = 'auth_letter';
